import deepmerge from 'deepmerge'

export const omit = <T extends object, K extends keyof T>(
  obj: T,
  keys: K[]
): Omit<T, K> => {
  const copy = { ...obj }
  keys.forEach((key) => {
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete copy[key]
  })
  return copy
}

export const hasValue = (value: unknown): boolean => {
  if (value === undefined || value === null) {
    return false
  }
  if (typeof value === 'number') {
    return !isNaN(value)
  }
  if (value === true || value === false) {
    return true
  }
  if (typeof value !== 'object') {
    return Boolean(value)
  }
  if (Array.isArray(value)) {
    return value.some(hasValue)
  }
  return Object.values(value).some(hasValue)
}

export const transformKebabCaseKeysToSnakeCase = <T extends object>(
  item: T
) => {
  const getValue = (value: unknown): unknown => {
    if (Array.isArray(value)) {
      return value.map((v) => getValue(v))
    }
    if (typeof value === 'object' && value !== null) {
      return transformKebabCaseKeysToSnakeCase(value)
    }

    return value
  }

  return Object.fromEntries(
    Object.entries(item).map(([key, value]) => {
      const newValue = getValue(value)
      return [`${key.replace(/-/g, '_')}`, newValue]
    })
  )
}

export const deepMerge = <T extends object>(
  obj1: T | undefined,
  obj2: T | undefined
): T | undefined => {
  if (obj1 && obj2) {
    return deepmerge(obj1, obj2)
  }
  if (obj1) {
    return obj1
  }
  if (obj2) {
    return obj2
  }
  return undefined
}
